// removed by extract-text-webpack-plugin
module.exports = {"root":"main__root","topAdContainer":"main__topAdContainer","topAd":"main__topAd","freewheelAd":"main__freewheelAd main__topAd","header":"main__header"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/containers/main/styles.less
 ** module id = 448
 ** module chunks = 1
 **/